// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4QBzA","modal__inner":"modal_modal__inner__uLDap","wide":"modal_wide__AOSw5","modal__inner-logo":"modal_modal__inner-logo__K+KIe"};